export default "__VITE_ASSET__BDHjd63X__"